import { Component, OnInit } from '@angular/core';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';
import { BookingProductStepService } from '../../services/booking-product-step.service';

@Component({
  selector: 'app-booking-product-authentication',
  templateUrl: './booking-product-authentication.component.html',
  styleUrls: ['./booking-product-authentication.component.css']
})
export class BookingProductAuthenticationComponent implements OnInit {

  hideNavigation = true;

  constructor(
    private bookingProductStepService: BookingProductStepService,
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  ngOnInit(): void {
  }

  onBack(): void {
    this.bookingProductStepService.back();
  }

  loggedIn(): void {
    this.bookingProductStepService.authorizationAsGuest = false;
    this.bookingProductStepService.forward();
  }

  onNavigationVisibilityChange(showNavigationBack: boolean): void {
    this.hideNavigation = !showNavigationBack;
  }

  authorizationAsGuest(): void {
    this.bookingProductStepService.authorizationAsGuest = true;
    this.bookingProductStepService.forward();
  }

  get allowGuestSale(): boolean {
    return this.shopSettingsService?.shopSettings?.allowGuestSale;
  }
}
